import React from 'react';
import AddRuleItem from './AddRuleItem';

class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.defaultState = this.defaultState.bind(this);
        this.swapEdit = this.swapEdit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.defaultState();
    }

    swapEdit(e) {
        this.setState({'isEditing':!this.state.isEditing});
    }

    defaultState(props) {
        this.state = {
            'isEditing':false,
            'value':this.props.onlyDescription ? false:this.props.rule.value
        };      
    }

    handleKeyPress(e) {
    	let value = e.target.value;

        this.props.handleChange(this.props.rule.id,{
            ...this.props.rule,
            value:value,
        });

		if (e.key === 'Enter') {

			this.setState({value:value});
			this.swapEdit();
		}
    }

    handleTextChange(e) {
    	this.setState({value:e.target.value});
    }

    componentDidUpdate() {
        if(this.state.isEditing) {
            this.refs.valuetext.focus();
        }
    }
  

    render() {

        if(this.props.onlyDescription) {
            return <AddRuleItem select={this.props.addRule} value="Click here to add address" operator="%%" action="Who" ruleKey={this.props.ruleKey} title="Address" description="Only show to customers who are visiting a spesific address" />
        }
        return (
                <div className="list-group-item blue-grey-500">    
                    <i className="icon wb-arrow-right" aria-hidden="true"></i>
                    Display to visitors who is at a url matching <strong>*</strong>&nbsp;
                    {
                    	 !this.state.isEditing
                    	 ?
                    	 <span onClick={(e) => {e.stopPropagation();this.swapEdit(e);} } className="selected-rule">{this.props.rule.value}</span>
                    	 :<div className="form-group form-material">
	                  <input type="text" ref="valuetext" className="form-control" style={{width:'60px'}} onChange={this.handleTextChange} onKeyUp={this.handleKeyPress} value={this.state.value} / >
	                </div>
                    }
                    &nbsp; <strong>*</strong>.
                    <div className="remove-rule"><a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.props.handleRemove(this.props.rule.id)}}><i className="icon wb-close"></i></a></div>
                </div>
        );
    }

  
}

export default Rule;




// WEBPACK FOOTER //
// ./components/builder/RuleShowOnPath.js